import {
  createResponderContext,
  handleClientMessage,
  ResponderContext,
} from './mockResponder';

type Handler<E> = ((event: E) => void) | null;

const READY_STATE_OPEN = 1;
const READY_STATE_CLOSED = 3;

export class MockWebSocket {
  onopen: Handler<Event> = null;
  onmessage: Handler<MessageEvent> = null;
  onerror: Handler<Event> = null;
  onclose: Handler<CloseEvent> = null;

  readyState: number = READY_STATE_CLOSED;

  readonly CONNECTING = 0;
  readonly OPEN = READY_STATE_OPEN;
  readonly CLOSING = 2;
  readonly CLOSED = READY_STATE_CLOSED;

  private ctx: ResponderContext = createResponderContext();
  private timers: ReturnType<typeof setTimeout>[] = [];

  constructor() {
    setTimeout(() => {
      this.readyState = READY_STATE_OPEN;
      this.onopen?.(new Event('open'));
    }, 0);
  }

  send(data: string): void {
    const replies = handleClientMessage(data, this.ctx);
    replies.forEach(({ delayMs, payload }) => {
      const handle = setTimeout(() => {
        this.onmessage?.({ data: JSON.stringify(payload) } as MessageEvent);
      }, delayMs);
      this.timers.push(handle);
    });
  }

  close(): void {
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.readyState = READY_STATE_CLOSED;
  }

  reconnect(): void {
    this.readyState = READY_STATE_OPEN;
    setTimeout(() => this.onopen?.(new Event('open')), 0);
  }
}
